import Hero from './components/Hero';
import Timeline from './components/Timeline';
import EngagementGallery from './components/EngagementGallery';
import PhotoCarousel from './components/PhotoCarousel';
import { milestones, weddingDate } from './config/milestones';
import { photos } from './config/photos';
import { engagementPhotos } from './config/engagementPhotos';
import './App.css';

function App() {
  return (
    <div className="app">
      <Hero weddingDate={weddingDate} />
      <main className="app-main">
        <Timeline milestones={milestones} weddingDate={weddingDate} />
        <EngagementGallery photos={engagementPhotos} />
        <PhotoCarousel photos={photos} />
      </main>
      <footer className="app-footer">B &amp; L · est. 2019 · August 20, 2027</footer>
    </div>
  );
}

export default App;
